/**
 * Typed errors for the intake API client. Components use `instanceof` checks
 * to pick the right user-facing copy (retry, refresh, or fatal).
 */

export class IntakeApiError extends Error {
  override name = 'IntakeApiError';
}

/** Network-layer failure — fetch threw or timed out. Usually recoverable. */
export class NetworkError extends IntakeApiError {
  override name = 'NetworkError';
  constructor(message = 'Network request failed') {
    super(message);
  }
}

/** Worker returned a non-2xx status. `status` is the HTTP code;
 *  `body` is whatever JSON/text came back (or null). */
export class WorkerHttpError extends IntakeApiError {
  override name = 'WorkerHttpError';
  constructor(
    public readonly status: number,
    public readonly body: unknown,
    message?: string,
  ) {
    super(message ?? `Worker returned ${status}`);
  }
}

/** Worker returned 2xx but the body didn't match the expected IntakeResponse
 *  shape. Client-side contract drift — surface as a fatal error. */
export class ContractError extends IntakeApiError {
  override name = 'ContractError';
}
